import { Component, uiElement, uiEvent } from "@kluntje/core";
import { hasClass } from "@kluntje/js-utils/lib/dom-helpers";
import { Toggle } from "Components/wec-e-toggle/wec-e-toggle";
import { CONSENT_CATEGORY_CHANGED_EVENT, CHANGED_EVENT } from "Constants/eventTypes";
import ConsentManagementService from "Services/ConsentManagementService";

export class CookieSettingsCategory extends Component {
  @uiElement(".wec-e-toggle")
  toggle: Toggle;

  get category(): string {
    return this.getAttribute("category") || "";
  }

  get isDisabled(): boolean {
    return this.toggle.isDisabled;
  }

  get isCategoryToggle(): boolean {
    return hasClass(this, ".wec-m-cookie-settings-category--category-toggle");
  }

  get consent(): boolean {
    return this.toggle.active;
  }

  set consent(newConsentState: boolean) {
    if (this.consent === newConsentState) return;
    this.toggle.active = newConsentState;
  }

  silentStateChange(newConsentState: boolean) {
    this.toggle.silentStateChange(newConsentState);
  }

  afterComponentRender() {
    this.connectToConsentManagement();
  }

  connectToConsentManagement() {
    if (!this.isDisabled) this.consent = ConsentManagementService.getConsent(this.category);
    if (this.isCategoryToggle === false) {
      ConsentManagementService.observeCategory(this.category, () => this.handleConsentChanged());
    }
  }

  @uiEvent("toggle", CHANGED_EVENT)
  handleToggleChange() {
    this.fireChangedEvent();
  }

  updateConsent(newConsentState?: boolean) {
    if (newConsentState !== undefined) this.consent = newConsentState;
    if (this.isCategoryToggle === false) {
      ConsentManagementService.setConsent(this.category, this.consent);
    }
    this.fireChangedEvent();
  }

  handleConsentChanged() {
    if (this.isCategoryToggle === true) return;
    this.consent = ConsentManagementService.getConsent(this.category);
  }

  fireChangedEvent() {
    this.dispatchEvent(
      new CustomEvent(CONSENT_CATEGORY_CHANGED_EVENT, {
        detail: {
          category: this.category,
          consent: this.consent,
        },
      }),
    );
  }
}

customElements.define("wec-m-cookie-settings-category", CookieSettingsCategory);
